module.exports = __webpack_public_path__ + "img/bar-order.00ad81f6.svg";